interface NamedObject {
  name: string;
  [key: string | number]: any;
}

export const filterName = (searchText: string, namedObject: NamedObject) => {
  if (namedObject.name.toLowerCase().includes(searchText.toLowerCase()))
    return true;
  if ('analyzer' in namedObject) {
    if (
      namedObject.analyzer.name.toLowerCase().includes(searchText.toLowerCase())
    )
      return true;
  }
  return false;
};

export const sortByName = (
  namedObject1: NamedObject,
  namedObject2: NamedObject
) => {
  if (namedObject1.name <= namedObject2.name) return -1;
  return 1;
};
